import React, {Component} from 'react';
import {View} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';
import AppConfig from '../../../AppConfig';
import {RestaurantItem} from '../../../components/public/Restaurants/RestaurantItem';
import ActivityIndicatorWrapper from '../../../components/public/UI/ActivityIndicatorWrapper';

export class Restaurants extends Component {
    static displayName = Restaurants.name;


    constructor(props) {
        super(props);

        this.state = {
            restaurants: [],
            search: "",
            searching: false,
            loading: true
        };
    }

    componentDidMount() {
        this.search('');
    }

    render() {
        if (this.state.loading)
            return <ActivityIndicatorWrapper />


        return (
            <div className="row">
                {this.state.restaurants.map(item => <View className="col-md-6 col-lg-4" style={{ marginBottom: 15 }}>
                    <RestaurantItem
                        item={item}
                    />
                </View>)}
            </div>
        );
    }

    async search(text) {
        try {
            this.setState({
                search: text
            });

            if (this.searchTimer)
                clearTimeout(this.searchTimer);

            if (!text) {
                //return;
            }

            this.searchTimer = setTimeout(async () => {
                this.setState({
                    searching: true,
                });

                const response = await fetch(AppConfig.URL + '/PublicActions/FetchRestaurants?search=' + text, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        //'Anonymous-Id': ls.get("anonymousId")
                    },
                }
                );

                let data = await response.json();

                this.setState({
                    restaurants: data.restaurants,
                    searching: false,
                    loading: false,
                });
            }, 700);

            return;
        } catch (error) {
            console.error(error);

            this.setState({
                loading: false,
            });
        }
    }
}
